<template>
    <div class="py-10">
        <div class="p-0" style="border: none!important;">
            <div class="col-md-8 mx-auto">
                <v-btn v-if="has_item" outlined color="red" @click="resetFilter">
                    <span class="fa fa-trash-alt ml-1" style="font-size: 10pt"></span>
                    حذف فیلتر
                </v-btn>
            </div>

            <Categories ref="category" v-model="category"></Categories>

            <div class="col-md-8 mx-auto py-0 my-0">
                <city-selector :defaultEdit="true" ref="city" :force="true"></city-selector>

                <div v-for="(item,index) in properties">
                    <component :key="item.name"
                               :is="item.has_fields ? 'InDialogRangeField' : item.component"
                               :fields="item.has_fields"
                               :label="item.label"
                               item-value="key"
                               item-text="lable"
                               :items="item.items"
                               :multiple="item.multi"
                               chips
                               :name="item.name"
                               v-model="value[item.name]"
                               deletable-chips
                               small-chips
                               :max="item.counter"
                               :maxLength="item.max"
                               oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max; else if(Number(this.value) < Number(this.min) && this.type === 'number') this.value = this.min;"
                               :min="item.min"
                               :placeholder="item.placeholder"
                               outlined
                               clear-icon="mdi-close-circle-outline"
                               prepend-inner-icon="fa fa-pencil-alt"
                               clearable
                               dense
                               :type="item.type">
                    </component>
                </div>

                <v-text-field outlined dense clear-icon="mdi-close-circle-outline"
                              prepend-inner-icon="fa fa-pencil-alt"
                              clearable
                              name="keyword"
                              v-model="value.title"
                              label="کلمه کلیدی"
                              hint="دقت کنید : این کلمه در جستجوی دسته ی منتخب فیلتر خواهد شد.">
                </v-text-field>

                <v-btn @click="action" color="warning" class="text-dark">
                    <span class="fa fa-filter"></span>
                    فیلترکن
                </v-btn>

            </div>
        </div>

    </div>
</template>

<script>
import CitySelector from "./citySelector";
import {Bus} from "../../../../main";
import InDialogRangeField from '../divarNews/inDialogRangeField';
import {VAutocomplete, VSelect, VSwitch, VTextarea, VTextField} from "vuetify/lib/components";
import Categories from "../Rp/Categories";

export default {
    name: "filters",
    components: {Categories, CitySelector, InDialogRangeField},
    props: {
        value: {
            required: true,
            type: Object
        },
        action: {
            required: true,
            type: Function
        },
        resetBtn: {
            type: Function,
        },
    },
    data() {
        return {
            category: undefined,
            searchFields: [],
            customers: [],
            customer_id: undefined,
            has_item: false,
            inputs: {
                "radio": VSelect,
                "string": VTextField,
                "number": VTextField,
                "hierarchy_widget": VSelect,
                "SingleSelectHierarchyWidget": VSelect,
                "select": VAutocomplete,
                "textarea": VTextarea,
                "boolean": VSwitch,
                "array": VAutocomplete,
                "object": VAutocomplete,
            },
        }
    },
    methods: {
        resetFilter() {
            this.has_item = false;
            this.category = undefined;
            this.$refs.city.cityInfo.city = 'root';
            this.$refs.city.cityInfo.neighborhood = '';
            this.$refs.city.neighborhood = [];
            this.$refs.category.breadcrumb = [];
            this.$refs.category.before = [];
            this.$refs.category.current = 'real-estate';
            this.searchFields = [];

            this.resetBtn();

            this.$emit("input", {});
        },
        * range(start, end) {
            for (let index = start; index <= end; index++)
                yield index;
        },
        getNewCategories() {
            if (localStorage.getItem('searchCategory')) {
                this.translates = JSON.parse(localStorage.getItem('searchCategory'));
                return;
            }
            $.ajax({
                url: `${url}/user/divar/search/category`,
                type: "GET",
                fn: this.getNewCategories,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token
                },
                success: (data) => {
                    this.translates = data.data
                    localStorage.setItem('searchCategory', JSON.stringify(data.data))
                }
            })
        },
        getProperty(key) {
            const name = key.name;
            const min = key.min;
            const max = key.max;
            const help = key.placeholder;
            const requireField = key.required;
            const placeholder = 'جستجوی ' + key.label + ' ' + 'موردنظر';
            const autoReload = key.auto_refresh
            const field_type = key.field_type
            const has_field = key.fields
            const multi = key.type === "InDialogMultiSelectField" || key.type === "CustomFilterNestedMultiSelectField";
            let items = [];
            let type = key.field_type !== null ? key.field_type : (key.field_type !== 'integer' ? key.field_type : "number");
            let title = key.label;
            let itemValue = key.enum ?? [];
            let itemText = key.enumNames ?? itemValue;

            if (title === "آگهی‌دهنده" || title === "نوع آگهی‌دهنده ") {
                itemText.push("همه");
                itemValue.push(null);
            }

            itemValue.forEach((item, index) => {
                items.push({
                    key: item,
                    lable: itemText[index]
                })
            })

            if (name === "building-age")
                return {
                    component: this.inputs['object'],
                    label: title,
                    counter: 1500,
                    hint: help ? help : null,
                    items: items,
                    name: "year",
                    value: "",
                    required: requireField,
                    placeholder: placeholder,
                    errorMessage: "",
                    autoReload: autoReload,
                    type: "object",
                    has_fields: {
                        min: {
                            enum: [...this.range(1300, 1405)],
                            enumNames: [...this.range(1300, 1405)]
                        },
                        max: {
                            enum: [...this.range(1300, 1405)],
                            enumNames: [...this.range(1300, 1405)]
                        }
                    },
                    multi: multi,
                    Fielad_type: 'object'
                };

            if (name === "rooms")
                return {
                    component: this.inputs['object'],
                    label: title,
                    hint: help ? help : null,
                    items: [
                        {
                            key: 0,
                            value: 0,
                        },
                        {
                            key: 1,
                            value: 1,
                        },
                        {
                            key: 2,
                            value: 2,
                        },
                        {
                            key: 3,
                            value: 3,
                        },
                        {
                            key: 4,
                            value: 4,
                        },
                        {
                            key: 5,
                            value: 5,
                        },
                        {
                            key: 6,
                            value: 6,
                        },
                    ],
                    name: "rooms",
                    value: "",
                    required: requireField,
                    placeholder: placeholder,
                    errorMessage: "",
                    autoReload: autoReload,
                    type: "object",
                    has_fields: {
                        min: {
                            enum: [...this.range(0, 6)],
                            enumNames: [...this.range(0, 6)]
                        },
                        max: {
                            enum: [...this.range(0, 6)],
                            enumNames: [...this.range(0, 6)]
                        }
                    },
                    multi: multi,
                    Fielad_type: 'object'
                };

            return {
                component: this.inputs[type],
                label: title,
                counter: max ? max : null,
                hint: help ? help : null,
                items: items,
                name: name === "price" ? 'credit' : name,
                min: min,
                value: "",
                required: requireField,
                placeholder: placeholder,
                errorMessage: "",
                autoReload: autoReload,
                type: type,
                has_fields: has_field,
                multi: multi,
                Fielad_type: field_type
            };
        },
        translator(name) {
            return this.translates[name];
        },
        getAds() {
            $.ajax({
                url: `${url}/user/divar/search/fields/${this.translator(this.value.category)}`,
                method: "GET",
                fn: this.getAds,
                headers: {
                    Authorization: Token,
                    ACCEPT: "application/json"
                },
                success: (res) => {
                    this.searchFields = res.data;
                }
            });
        },

    },
    watch: {
        category(value) {
            this.value.category = value.slug;

            this.getAds();

            this.has_item = true;
        },
    },
    computed: {
        properties() {
            const baneList = [
                "bizzDeed",
                "category",
                "districts",
                "divider",
                "user_type",
                "has-photo",
                "has-video",
                "non-negotiable",
                "real_estate_vr",
                "urgent"
            ];

            let data = [];

            const filtered = this.searchFields.filter((x) => x.type !== "hidden" && (baneList.indexOf(x.name) < 0))

            filtered.forEach((item) => {
                data.push(this.getProperty(item));
            });

            return data;
        }
    },
    mounted() {
        this.getNewCategories();
        Bus.$on('dialogRange', (name, value = null) => {
            this.value[name] = value;
        });

        Bus.$on('cityInfo', (value) => {
            if (value.city !== "root" || value.neighborhood !== "")
                this.value = Object.assign(this.value, value);
        });
    }
}
</script>

<style scoped>

</style>